/* unplugin-vue-components disabled */import { render } from "./SvgSymbols.vue?vue&type=template&id=11da08a9"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__